import React, { useEffect } from "react";
import { LoginCallback, useOktaAuth } from "@okta/okta-react";
import { Navigate, Route, Routes } from "react-router-dom";
import { RouteConstants } from "../constants/route";
import { SSOLoginForm, useLoading } from "best-common-react";
import styled from "styled-components";

import FieldBackDrop from "../assets/field-backdrop.png";

const Container = styled.div`
  height: 100vh;
  width: 100vw;
`;

type LoginProps = {
  login: () => void;
};

const Login: React.FC<LoginProps> = ({ login }) => (
  <SSOLoginForm title="Bullseye" signInText="Sign In with Okta SSO" signIn={login} backDrop={FieldBackDrop} />
);

let handledLogin = false;

const InitiateLogin: React.FC<LoginProps> = ({ login }) => {
  useEffect(() => {
    if (!handledLogin) {
      handledLogin = true;
      login();
    }
  }, []);

  return null;
};

const UnauthenticatedApp: React.FC = () => {
  const { setAnimated, setLabel } = useLoading();
  const { oktaAuth } = useOktaAuth();

  useEffect(() => {
    setAnimated(true);
    setLabel("…please wait a moment…");
  }, []);

  const login = (): void => {
    oktaAuth.signInWithRedirect({ originalUri: "/" }).catch(console.error);
  };

  return (
    <Container>
      <Routes>
        <Route path={RouteConstants.BASE} element={<Login login={login} />} />
        <Route path={RouteConstants.LOGIN.CALLBACK} element={<LoginCallback />} />
        <Route path={RouteConstants.LOGIN.INITIATE} element={<InitiateLogin login={login} />} />
        <Route path={RouteConstants.WILDCARD} element={<Navigate to={RouteConstants.BASE} replace />} />
      </Routes>
    </Container>
  );
};

export default UnauthenticatedApp;
